import { Option, TranslationFunction } from '@/types';

export const optionsLineChart = {
  plugins: {
    tooltip: {
      displayColors: false,
      yAlign: 'bottom'
    },
    legend: {
      display: false
    }
  },
  scales: {
    y1: {
      min: 0
    }
  }
};

export const infoAboutSersor = ($t: TranslationFunction): Option[] => [
  {
    label: $t('id'),
    value: 'id'
  },
  {
    label: $t('name'),
    value: 'name'
  },
  {
    label: $t('serialNumber'),
    value: 'sn'
  },
  {
    label: $t('description'),
    value: 'description'
  }
];

export const optionsSortAllSensors = ($t: TranslationFunction): Option[] => [
  {
    value: 'all',
    label: $t('allInOne')
  },
  {
    value: 'byCategory',
    label: $t('byCategory')
  },
  {
    value: 'split',
    label: $t('split')
  }
];

export const columns = ($t: TranslationFunction): Option[] => [
  {
    value: 'sensorAlarmType',
    label: $t('causeOfAlarmUpperCase')
  },
  {
    value: 'nameSensor',
    label: $t('nameUpperCase')
  },
  {
    value: 'alarmStartTimestamp',
    label: $t('startTimeUpperCase')
  },
  {
    value: 'alarmEndTimestamp',
    label: $t('endTimeUpperCase')
  },
  {
    value: 'duration',
    label: $t('durationUpperCase')
  },
  {
    value: 'alarmMax',
    label: $t('maxUpperCase')
  },
  {
    value: 'alarmMin',
    label: $t('minUpperCase')
  },
  {
    value: 'averageTemp',
    label: $t('averageUpperCase')
  },
  {
    value: 'alarmComment',
    label: $t('alarmCommentUpperCase')
  }
];

export const columnsById = ($t: TranslationFunction): Option[] => [
  {
    value: 'sensorAlarmType',
    label: $t('causeOfAlarmUpperCase')
  },
  {
    value: 'alarmStartTimestamp',
    label: $t('startTimeUpperCase')
  },
  {
    value: 'alarmEndTimestamp',
    label: $t('endTimeUpperCase')
  },
  {
    value: 'duration',
    label: $t('durationUpperCase')
  },
  {
    value: 'alarmMax',
    label: $t('maxUpperCase')
  },
  {
    value: 'alarmMin',
    label: $t('minUpperCase')
  },
  {
    value: 'averageTemp',
    label: $t('averageUpperCase')
  },
  {
    value: 'alarmComment',
    label: $t('alarmCommentUpperCase')
  }
];
